import React, { useCallback } from "react";
import { MenuItem, FormGroup, Callout } from "@blueprintjs/core";
import { ItemRenderer, MultiSelect } from "@blueprintjs/select";
import { NewScheduleState } from "types";
import { generateNumbers } from "utils/utils";

type Props = {
    days: number[];
    update: (name: keyof NewScheduleState, value: number[]) => void;
};
export default function DayOfMonth({ days, update }: Props) {
    const isItemSelected = useCallback(
        (n) => {
            return days.includes(n);
        },
        [days]
    );

    const handleSelect = useCallback(
        (addedDay: number) => {
            const updated = days.includes(addedDay) ? days.filter((day) => day !== addedDay) : [...days, addedDay];
            update("daysOfMonth", updated);
        },
        [days, update]
    );
    const handleRemove = useCallback(
        (removedDay: number) => {
            const updated = days.filter((day) => day !== removedDay);
            update("daysOfMonth", updated);
        },
        [days, update]
    );

    const renderList: ItemRenderer<number> = useCallback(
        (day, { modifiers, handleClick }) => {
            if (!modifiers.matchesPredicate) {
                return null;
            }
            return (
                <MenuItem
                    active={modifiers.active}
                    icon={isItemSelected(day) ? "tick" : "blank"}
                    key={`day_${day}`}
                    onClick={handleClick}
                    text={day}
                    shouldDismissPopover={false}
                />
            );
        },
        [isItemSelected]
    );

    return (
        <Callout>
            <FormGroup inline={false} label={"Days of the Month"} labelFor="text-input">
                <ListCollectorSelect
                    fill
                    placeholder="Days..."
                    itemRenderer={renderList}
                    items={generateNumbers(31)}
                    noResults={<MenuItem disabled={true} text="No results." />}
                    selectedItems={days}
                    onItemSelect={handleSelect}
                    onRemove={handleRemove}
                    popoverProps={{ minimal: true, popoverClassName: "custom-select" }}
                    tagRenderer={(n: number) => n}
                />
            </FormGroup>
        </Callout>
    );
}
const ListCollectorSelect = MultiSelect.ofType<number>();
